import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon77: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M7.5 9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0v-8a.5.5 0 0 1 .5-.5Zm5-3a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 .5-.5Zm5-1a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-1 0v-12a.5.5 0 0 1 .5-.5Zm-15 6a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0v-6a.5.5 0 0 1 .5-.5ZM19.89.188a.5.5 0 0 1-.078.702l-5 4a.5.5 0 0 1-.589.026L11.544 3.13 7.332 6.874a.5.5 0 0 1-.644.016l-2.15-1.72L.853 8.854a.501.501 0 0 1-.708-.707l4-4a.5.5 0 0 1 .666-.037l2.171 1.736 4.185-3.72a.5.5 0 0 1 .61-.042l2.695 1.797L19.188.11a.5.5 0 0 1 .702.078ZM.5 20h19a.5.5 0 0 0 0-1H.5a.5.5 0 0 0 0 1Z"
      />
    </Svg>
  )
}
